/**
 * Менеджер для управления dropdown элементами
 * Обеспечивает закрытие всех остальных dropdowns при открытии одного
 */

export function initDropdownManager() {
    const dropdowns = document.querySelectorAll('.dropdown');
    
    dropdowns.forEach(el => {
        el.onclick = (event) => {
            // Предотвращаем всплытие события для корректной работы
            event.stopPropagation();
            
            // Проверяем, является ли это dropdown в первом item-delivery (личные адреса)
            const itemDelivery = el.closest('.item-delivery');
            const isFirstItemDelivery = itemDelivery && 
                itemDelivery === document.querySelectorAll('.item-delivery')[0];
            
            if (isFirstItemDelivery) {
                // Получаем адреса из общей переменной
                const savedAddresses = (window.__orderState && Array.isArray(window.__orderState.personalAddresses)) ? window.__orderState.personalAddresses : [];
                
                if (savedAddresses.length === 0) {
                    // Если адресов нет, открываем popup для добавления адреса
                    const modalElement = document.querySelector('[data-type="add-new-address"]');
                    if (modalElement) {
                        modalElement.dataset.modalState = "open";
                        document.documentElement.style.overflow = "hidden";
                        console.log('Открываем popup для добавления адреса - сохраненных адресов нет');
                    }
                    return; // Не открываем dropdown
                }
            }
            
            // Закрываем все остальные dropdowns перед открытием текущего
            closeAllOtherDropdowns(el);
            
            // Переключаем состояние текущего dropdown
            const dropdownBody = el.querySelector('.dropdown__body');
            if (dropdownBody) {
                dropdownBody.classList.toggle('none');
            }
        };
    });
    
    // Добавляем обработчик клика вне dropdown для закрытия всех dropdowns
    document.addEventListener('click', function(event) {
        const clickedElement = event.target;
        const isDropdownClick = clickedElement.closest('.dropdown');
        
        if (!isDropdownClick) {
            closeAllDropdowns();
        }
    });
    
    console.log('✅ Dropdown менеджер инициализирован');
}

/**
 * Закрывает все dropdowns кроме указанного
 * @param {Element} excludeDropdown - dropdown который не нужно закрывать
 */
export function closeAllOtherDropdowns(excludeDropdown = null) {
    const allDropdownBodies = document.querySelectorAll('.dropdown .dropdown__body');
    allDropdownBodies.forEach(dropdownBody => {
        if (!excludeDropdown || dropdownBody !== excludeDropdown.querySelector('.dropdown__body')) {
            dropdownBody.classList.add('none');
        }
    });
}

/**
 * Закрывает все dropdowns
 */
export function closeAllDropdowns() {
    const allDropdownBodies = document.querySelectorAll('.dropdown .dropdown__body');
    allDropdownBodies.forEach(dropdownBody => {
        dropdownBody.classList.add('none');
    });
}

/**
 * Открывает указанный dropdown и закрывает все остальные
 * @param {Element} dropdown - dropdown который нужно открыть
 */
export function openDropdown(dropdown) {
    closeAllOtherDropdowns(dropdown);
    const dropdownBody = dropdown.querySelector('.dropdown__body');
    if (dropdownBody) {
        dropdownBody.classList.remove('none');
    }
}

// Инициализация при загрузке страницы
document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
        initDropdownManager();
    }, 100);
});

// Экспортируем функции в глобальную область для использования в других модулях
window.closeAllOtherDropdowns = closeAllOtherDropdowns;
window.closeAllDropdowns = closeAllDropdowns;
window.openDropdown = openDropdown; 